import React from 'react';
import { CpuIcon, HelpCircleIcon, PlugIcon, SearchIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { nextQuestions, sampleCodes } from '../data/content';
const sequence = [{
  icon: CpuIcon,
  text: 'A vehicle arrives with the Check Engine light on.'
}, {
  icon: PlugIcon,
  text: 'You connect your scanner.'
}, {
  icon: SearchIcon,
  text: 'You retrieve a diagnostic trouble code.'
}];
export function ProblemSection() {
  return <section className="border-t border-line bg-panel px-4 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-249" data-mp="39jqls1puntd4">
      <div className="mx-auto max-w-3xl" data-id="element-250" data-mp="3jg200x902ta7">
        <h2 id="problem-title" className="text-center font-display text-4xl font-extrabold uppercase leading-[1.02] text-white sm:text-5xl" data-id="element-251" data-mp="3jf0pquzt6atj">
          If you work with diagnostics, you’ve <span className="text-amber" data-id="element-252" data-mp="1p2u3901gs7lx">lived this</span>
        </h2>

        <ol className="mt-10 space-y-3" data-id="element-253" data-mp="1k3heg9r18qgp">
          {sequence.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex items-center gap-4 rounded-xl bg-panel2 px-4 py-4" data-id="element-254" data-mp="jdn5i4pl305g">
              <Icon className="h-6 w-6 shrink-0 text-amber" aria-hidden="true" data-id="element-255" data-mp="obyde9wbj0l1" />
              <span className="text-lg font-medium text-white" data-id="element-256" data-mp="sdtg9itwdm0x">{text}</span>
            </li>)}
        </ol>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-3" data-id="element-257" data-mp="x49wfap3rlqz">
          {sampleCodes.map(code => <span key={code} className="rounded-lg border-2 border-signal bg-[#1A0B0E] px-4 py-2 font-mono text-2xl font-bold text-[#FF6B66]" data-id="element-258" data-mp="122jpnfr9oc9y">
              {code}
            </span>)}
        </div>
        <p className="mt-4 text-center text-lg text-mist" data-id="element-259" data-mp="1bzy63fd6x129">You know what the code description says. But here’s the real question:</p>

        <div className="mt-8 rounded-2xl bg-amber px-5 py-8 text-center" data-id="element-260" data-mp="3dtnljwil6h1c">
          <HelpCircleIcon className="mx-auto h-10 w-10 text-ink" aria-hidden="true" data-id="element-261" data-mp="3hur44qs0qr69" />
          <p className="mt-3 font-display text-4xl font-extrabold uppercase leading-none text-ink sm:text-5xl" data-id="element-262" data-mp="3hwttr9p9eiag">
            “What should I actually check next?”
          </p>
        </div>

        <ul className="mt-8 divide-y divide-line border-y border-line" data-id="element-263" data-mp="k30jhsljj8ec">
          {nextQuestions.map(q => <li key={q} className="py-3.5 text-lg text-white" data-id="element-264" data-mp="xym31k908zzd">
              {q}
            </li>)}
        </ul>

        <div className="mt-10 space-y-5 text-lg leading-relaxed text-mist" data-id="element-265" data-mp="17yv3xbdxz9l3">
          <p data-id="element-266" data-mp="17ws4k0qwg43p">This is where many diagnostic investigations become frustrating.</p>
          <p className="font-display text-3xl font-bold uppercase leading-tight text-white" data-id="element-267" data-mp="12zry3oq50zc2">
            Because reading a fault code is <span className="text-signal" data-id="element-268" data-mp="1cpuxc6nur9iu">not</span> the same as diagnosing the
            problem.
          </p>
          <p data-id="element-269" data-mp="1qpcpmw0cx4wy">
            Inside this collection, you’ll discover a structured way to interpret codes, organize available
            evidence, understand relevant diagnostic data, and select your next investigative step.
          </p>
          <p className="text-white" data-id="element-270" data-mp="25dmjamd0gz0o">
            You don’t need another endless list of fault codes. You need a system that helps you understand what
            those codes are telling you — <strong data-id="element-271" data-mp="1wcem67m8e486">and what they aren’t.</strong>
          </p>
        </div>

        <CtaButton className="mt-10" label="Get instant access for $27" sub="One-Time Payment · No Monthly Fees · Lifetime Access" data-id="element-272" data-mp="20cylnhua1jxh" />
      </div>
    </section>;
}